import type { LevelData, LevelTrack, PuzzleDifficulty } from '../types';
import { parseLevelJSON, type LevelJSON } from './parsePuzzle';
import { LEVELS } from '../levels/manifest';
import { manifestedModules } from './manifested-levels';

function resolve(manifestPath: string): LevelJSON {
  const mod = manifestedModules[manifestPath];
  if (!mod) throw new Error(`Level not found: ${manifestPath}`);
  return mod;
}

function loadLevel(manifestPath: string): LevelData {
  return parseLevelJSON(resolve(manifestPath), manifestPath);
}

// --- Public exports (only manifested levels — eagerly bundled) ---

export const LEVEL_DATA: Record<LevelTrack, Record<PuzzleDifficulty, LevelData[]>> = {
  progression: {
    casual: LEVELS.progression.casual.map(loadLevel),
    advanced: LEVELS.progression.advanced.map(loadLevel),
  },
  daily: {
    casual: LEVELS.daily.casual.map(loadLevel),
    advanced: LEVELS.daily.advanced.map(loadLevel),
  },
};
